/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Voucher_ApplyInputs */

const en_voucher_apply = /** @type {(inputs: Voucher_ApplyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apply`)
};

const id_voucher_apply = /** @type {(inputs: Voucher_ApplyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pakai`)
};

/**
* | output |
* | --- |
* | "Apply" |
*
* @param {Voucher_ApplyInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const voucher_apply = /** @type {((inputs?: Voucher_ApplyInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Voucher_ApplyInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_voucher_apply(inputs)
	return en_voucher_apply(inputs)
});